import { useState, useEffect, useCallback } from "react";
import { useLocation, Link } from "react-router-dom";
import Layout from "@/components/Layout";
import { getCasinoGameDetails, getMatchExposure } from "@/services/casinoApi";
import CasinoHeading from "../components/common/CasinoHeading";
import VideoBox from "../components/common/VideoBox";
import BetTableAB20 from "../components/ab20/BetTableAB20";
import ResultAB20 from "../components/ab20/ResultAB20";
import RightSection from "../components/RightSection/RightSection";
import styles from "./AB20.module.css";

function extractCasinoGame(url) {
  const match = url.match(/\/lord-games\/([^/?#]+)/);
  return match ? match[1] : null;
}

export default function AB20() {
  const [gameData, setGameData] = useState([]);
  const [activeTab, setActiveTab] = useState("game");
  const [iframeSrc, setIframeSrc] = useState("");
  const { pathname } = useLocation();
  const [subData, setSubData] = useState([]);
  const [exposures, setExposures] = useState({});
  const [myBets, setMyBets] = useState([]);

  useEffect(() => {
    const name = extractCasinoGame(pathname) || "ab20";
    setIframeSrc(`https://casino-stream.softgamingapi.com/casino-tv?id=${name}`);

    const fetchGameData = async () => {
      try {
        const response = await getCasinoGameDetails(name);
        setGameData(response);
        const data = response?.data?.data?.sub || [];
        setSubData(data);
      } catch (err) {
        console.error("Error fetching game data:", err);
      }
    };

    let intervalId = null;
    const initialTimeout = setTimeout(() => {
      fetchGameData();
      intervalId = setInterval(fetchGameData, 1500);
    }, 5000);

    return () => {
      clearTimeout(initialTimeout);
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [pathname]);

  const fetchExposure = useCallback(async () => {
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      const userId = user?.user_id || user?.id;
      const matchId = gameData?.data?.data?.mid?.toString() ||
        gameData?.data?.mid?.toString() ||
        gameData?.mid?.toString();

      if (userId && matchId) {
        const response = await getMatchExposure(userId, matchId);
        if (response.success && response.data) {
          const exposureMap = {};
          response.data.forEach((item) => {
            exposureMap[item.team_name] = parseFloat(item.exposure_amount) || 0;
          });
          setExposures(exposureMap);
        }
      }
    } catch (error) {
      console.error('Error fetching exposure:', error);
    }
  }, [gameData?.data?.data?.mid, gameData?.data?.mid, gameData?.mid]);

  useEffect(() => {
    if (gameData?.data?.data?.mid || gameData?.data?.mid || gameData?.mid) {
      fetchExposure();
      const exposureInterval = setInterval(() => {
        fetchExposure();
      }, 2000);
      return () => clearInterval(exposureInterval);
    }
  }, [gameData?.data?.data?.mid, gameData?.data?.mid, gameData?.mid, fetchExposure]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const roundId = gameData?.data?.data?.mid || gameData?.data?.mid || gameData?.mid || "0";

  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.sectionA}>
          <CasinoHeading
            name="ANDAR BAHAR 20"
            roundId={roundId}
            activeTab={activeTab}
            onTabChange={handleTabChange}
          />
          {activeTab === "game" && (
            <>
              <VideoBox iframeSrc={iframeSrc} timerValue={gameData?.data?.data?.lt} />
              <div className={styles.tableContainer}>
                <BetTableAB20
                  data={subData}
                  exposures={exposures}
                  gameData={gameData}
                />
              </div>
              <div className={styles.heading}>
                <div>Last Result</div>
                <Link to="/admin/reports/casinoresult/ab20">
                  <div style={{ cursor: "pointer" }}>View All</div>
                </Link>
              </div>
              <ResultAB20
                data={gameData?.lrs || []}
                gameData={gameData}
                gameType="ab20"
              />
            </>
          )}
        </div>
        <RightSection />
      </div>
    </Layout>
  );
}

